module.exports = __webpack_public_path__ + "img/project4.1f27d17d.png";